import {
    ChipDateRangePicker,
    ChipMenu,
    MenuItemProps,
    useListFilterState,
    useTranslation,
    useTranslations,
} from "@bsm/component";
import { useCallback, useMemo } from "react";
import _ from "lodash";
import { useDepartmentList } from "views/dayoff/hooks/useDepartmentList";

export const DayOffMissingListQuickFilter = (props: Props) => {
    const [DATERANGE, DEPARTMENT] = useTranslations(i18n);
    const t = useTranslation();

    const { filter, setFilter } = useListFilterState(props.listId);
    const departments = useDepartmentList();

    const departmentStatusMenuItems = departments

    const activeDepartmentMenu = useMemo(() => {
        const departmentId = filter.data?.employee?.department?.id;
        if (departmentId) {
            return departmentStatusMenuItems.find((dept) => dept.value === departmentId);
        }
        return departmentStatusMenuItems.find((dept) => dept.value === -1);
    }, [filter.data?.employee?.department?.id, departmentStatusMenuItems]);

    const dateRange = useMemo((): [string, string] | undefined => {
        if (filter?.data?.dateBegin_supOrEquals) {
            return [
                filter?.data?.dateBegin_supOrEquals,
                filter?.data?.dateEnd_infOrEquals,
            ];
        }

        return undefined;
    }, [filter]);

    const handleDateRangeChange = useCallback(
        (value: [string, string]) => {
            setFilter((v: any) => ({
                ...v,
                data: {
                    ...v.data,
                    dateBegin_supOrEquals: value?.[0],
                    dateEnd_infOrEquals: value?.[1]
                },
            }));
        },
        [filter, dateRange]
    );

    const handleDepartmentMenuClick = (menu: MenuItemProps) => {
        setFilter((v: any) => ({
            ...v,
            data: {
                ...v.data,
                employee: {
                    department: { id: menu.value }
                }
            },
        }));
    };

    return (
        <div className="flex items-center justify-end gap-2">
            <ChipDateRangePicker
                defaultLabel={DATERANGE}
                value={dateRange}
                onChange={handleDateRangeChange}
            />

            <ChipMenu
                value={activeDepartmentMenu?.value}
                items={departmentStatusMenuItems}
                onClick={handleDepartmentMenuClick}
            />
        </div>
    );
};

const i18n = ["std_daterange", "std_department"];

type Props = {
    listId: string;
};